module.exports = __webpack_public_path__ + "img/vegetable-lettuce-350x184.2b78d434.jpg";